import { useState } from 'react';
import { requestAccess, TkwsApiError } from '@/shared/lib/tkws-api-client';

/**
 * Estado da submissão de "solicitar acesso". Sem TanStack Query (o login SPA não
 * monta um QueryClientProvider) — estado local simples é suficiente para um POST
 * único. Sucesso é sempre genérico (anti-enumeração: o backend nem revela se o
 * e-mail existe), então a UI mostra a mesma confirmação em qualquer caso de sucesso.
 */
export function useRequestAccess() {
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState<unknown>(null);

  async function mutateAsync(email: string): Promise<{ message: string }> {
    setIsPending(true);
    setError(null);
    try {
      return await requestAccess(email);
    } catch (e) {
      setError(e);
      throw e;
    } finally {
      setIsPending(false);
    }
  }

  function reset() {
    setError(null);
    setIsPending(false);
  }

  return { mutateAsync, isPending, isError: error != null, error, reset };
}

/** Mensagem amigável para o erro (rate limit vs. genérico). */
export function requestAccessErrorMessage(error: unknown): string {
  if (error instanceof TkwsApiError && error.status === 429) {
    return 'Muitas tentativas. Aguarde alguns minutos e tente novamente.';
  }
  if (error instanceof TkwsApiError && error.status === 400) {
    return 'Confira o e-mail informado e tente novamente.';
  }
  return 'Não foi possível enviar agora. Tente novamente em instantes.';
}
